import Login from "@/services/api_config/LoginApi";
import Rest from "@/services/api_config/RestApi";
import MicroFraud from "./api_config/MicroFraud";
import SoldRegisterApi from "@/services/api_config/SoldRegisterApi";
import ManualAggregateApi from "@/services/api_config/manualAggregateInsert";
import TransferApi from "@/services/api_config/TransferApi";


export default {
  login(credentials) {
    return Login().post("auth/tripko-login", credentials);
  },
  getPages(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    return Rest().get("tripko/page?" + data.substring(1));
  },
  getPage(id) {
    return Rest().get("tripko/page/" + id);
  },
  addPage(data) {
    return Rest().put("tripko/add-page", data);
  },
  editPage(id, data) {
    return Rest().patch("tripko/page/" + id, data);
  },
  deletePage(id) {
    return Rest().delete("tripko/page/" + id);
  },
  getModules(params) {
    var data = ``;
    if (
      params.page_id !== null &&
      params.page_id !== undefined &&
      params.page_id !== ""
    ) {
      data += `&page_id=${params.page_id}`;
    }
    return Rest().get("tripko/module?" + data.substring(1));
  },
  getModule(id) {
    return Rest().get("tripko/module/" + id);
  },
  addModule(data) {
    return Rest().put("tripko/add-module", data);
  },
  editModule(id, data) {
    return Rest().patch("tripko/module/" + id, data);
  },
  deleteModule(id) {
    return Rest().delete("tripko/module/" + id);
  },
  getRoles(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    return Rest().get("tripko/role?" + data.substring(1));
  },
  getRole(id) {
    return Rest().get("tripko/role/" + id);
  },
  editRole(id, data) {
    return Rest().patch("tripko/role/" + id, data);
  },
  deleteRole(id) {
    return Rest().delete("tripko/role/" + id);
  },
  addRole(data) {
    return Rest().put("tripko/add-role", data);
  },
  getCompanyRoles(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    return Rest().get("tripko/com/role?" + data.substring(1));
  },
  getCompanyRole(id) {
    return Rest().get("tripko/com/role/" + id);
  },
  addCompanyRole(data) {
    return Rest().put("tripko/com/add-role", data);
  },
  editCompanyRole(id, data) {
    return Rest().patch("tripko/com/role/" + id, data);
  },
  deleteCompanyRole(id) {
    return Rest().delete("tripko/com/role/" + id);
  },
  getCompanyPages(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    return Rest().get("tripko/com/page?" + data.substring(1));
  },
  getCompanyModules(params) {
    var data = ``;
    if (
      params.page_id !== null &&
      params.page_id !== undefined &&
      params.page_id !== ""
    ) {
      data += `&page_id=${params.page_id}`;
    }
    return Rest().get("tripko/com/module?" + data.substring(1));
  },
  getSubCompanyRoles(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get("tripko/sub/role?" + data.substring(1));
  },
  getSubCompanyRole(id) {
    return Rest().get("tripko/sub/role/" + id);
  },
  addSubCompanyRole(data) {
    return Rest().put("tripko/sub/add-role", data);
  },
  editSubCompanyRole(id, data) {
    return Rest().patch("tripko/sub/role/" + id, data);
  },
  deleteSubCompanyRole(id) {
    return Rest().delete("tripko/sub/role/" + id);
  },
  getSubCompanyPages(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    return Rest().get("tripko/sub/page?" + data.substring(1));
  },
  getSubCompanyModules(params) {
    var data = ``;
    if (
      params.page_id !== null &&
      params.page_id !== undefined &&
      params.page_id !== ""
    ) {
      data += `&page_id=${params.page_id}`;
    }
    return Rest().get("tripko/sub/module?" + data.substring(1));
  },

  getEmployees(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get("tripko/employee?" + data.substring(1));
  },
  getEmployee(id) {
    return Rest().get("tripko/employee/" + id);
  },
  editEmployee(id, data) {
    return Rest().patch("tripko/employee/" + id, data);
  },
  getUnassignedEmployees(params) {
    let data = ``;
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get("tripko/unassigned-employee?" + data.substring(1));
  },
  deleteEmployee(id) {
    return Rest().delete("tripko/employee/" + id);
  },
  assignEmployees(params) {
    return Rest().post("tripko/assign-employee/", params);
  },
  getUser(id) {
    return Rest().get("jti/user/" + id);
  },
  getAccessCard(id) {
    return Rest().get("jti/access-card/" + id);
  },
  getCompanies(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    return Rest().get("tripko/company?" + data.substring(1));
  },
  getCompany(id) {
    return Rest().get("tripko/company/" + id);
  },
  getDevices(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    return Rest().get("tripko/device?" + data.substring(1));
  },
  getDevice(id) {
    return Rest().get("tripko/device/" + id);
  },
  getDeviceSettings(id) {
    return Rest().get("tripko/device/settings/" + id);
  },
  editDeviceSettings(id, body) {
    return Rest().patch("tripko/device/settings/" + id, body);
  },
  editDevice(id, body) {
    return Rest().patch("tripko/device/" + id, body);
  },
  deleteDevice(id) {
    return Rest().delete("tripko/device/" + id);
  },
  getUnassignedDevices(params) {
    let data = ``;
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    return Rest().get("tripko/unassigned-device?" + data.substring(1));
  },
  assignDevices(data) {
    return Rest().post("tripko/assign-device/", data);
  },
  getSubCompanies(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    return Rest().get("tripko/sub-company?" + data.substring(1));
  },
  getTransactionTypes(params) {
    var data = "?";
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    return Rest().get("tripko/transaction-type" + data);
  },
  getTransactionType(id) {
    return Rest().get("tripko/transaction-type/" + id);
  },
  addTransactionType(data) {
    return Rest().put("tripko/add-transaction-type", data);
  },
  editTransactionType(id, data) {
    return Rest().patch("tripko/transaction-type/" + id, data);
  },
  deleteTransactionType(id) {
    return Rest().delete("tripko/transaction-type/" + id);
  },
  getContactNumber(params) {
    var data = "?";
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.transaction_type_id !== null &&
      params.transaction_type_id !== undefined &&
      params.transaction_type_id !== ""
    ) {
      data += `&transaction_type_id=${params.transaction_type_id}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    return Rest().get("/tripko/card-contact-no/" + data);
  },
  getMasterCards(params) {
    var data = ``;
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.terminal_id !== null &&
      params.terminal_id !== undefined &&
      params.terminal_id !== ""
    ) {
      data += `&terminal_id=${params.terminal_id}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    return Rest().get("/tripko/mastercard?" + data.substring(1));
  },
  getMasterCardsDLTB(params) {
    var data = ``;
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    if (
      params.terminal_id !== null &&
      params.terminal_id !== undefined &&
      params.terminal_id !== ""
    ) {
      data += `&terminal_id=${params.terminal_id}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    return Rest().get("/tripko/mastercard-dltb?" + data.substring(1));
  },
  getMasterCardFilters() {
    return Rest().get("/tripko/mastercard-filters?");
  },
  getMasterCardsDropdown(params) {
    var data = ``;

    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }

    return Rest().get("/tripko/mastercard-dropdown?" + data.substring(1));
  },
  getMasterCard(id) {
    return Rest().get("/tripko/mastercard/" + id);
  },
  addMasterCard(data) {
    return Rest().put("/tripko/add-mastercard", data);
  },
  editMasterCard(id, data) {
    return Rest().patch("tripko/mastercard/" + id, data);
  },
  deleteMasterCard(id) {
    return Rest().delete("tripko/mastercard/" + id);
  },
  getMasterCardContacts(params) {
    var data = ``;
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    return Rest().get("/tripko/mastercard-contact?" + data.substring(1));
  },
  getMasterCardContact(id) {
    return Rest().get("/tripko/mastercard-contact/" + id);
  },
  addMasterCardContact(data) {
    return Rest().put("/tripko/add-mastercard-contact", data);
  },
  editMasterCardContact(id, data) {
    return Rest().patch("tripko/mastercard-contact/" + id, data);
  },
  deleteMasterCardContact(id) {
    return Rest().delete("tripko/mastercard-contact/" + id);
  },
  getCredit(params) {
    var data = ``;
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.status !== null &&
      params.status !== undefined &&
      params.status !== ""
    ) {
      data += `&status=${params.status}`;
    }
    if (
      params.type !== null &&
      params.type !== undefined &&
      params.type !== ""
    ) {
      data += `&type=${params.type}`;
    }
    if (
      params.sms_status !== null &&
      params.sms_status !== undefined &&
      params.sms_status !== ""
    ) {
      data += `&sms_status=${params.sms_status}`;
    }
    return Rest().get("/tripko/credit?" + data.substring(1));
  },
  addCredit(data) {
    return Rest().put("/tripko/add-dispute", data);
  },
  addReplenish(data) {
    return Rest().put("/tripko/add-replenishment", data);
  },
  uploadBulkPromo(data) {
    return Rest().post("/tripko/promo/upload-bulk-promo", data);
  },
  cancelCredit(params) {
    return Rest().post("/tripko/cancel-credit/", params);
  },
  getShiftWireless(params) {
    var data = "?";
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    return Rest().get("tripko/shift/wireless" + data);
  },
  getShiftWirelessView(data, trasTypeExclusion) {
    return Rest().get(
      `tripko/transaction/wireless?shift_id=${data}&tras_type_exclusion=${trasTypeExclusion}`,
    );
  },
  getShiftSync(params) {
    var data = "?";
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    return Rest().get("tripko/shift/sync/" + data);
  },
  getShiftSyncView(data, trasTypeExclusion) {
    return Rest().get(
      `tripko/transaction/sync?shift_id=${data}&tras_type_exclusion=${trasTypeExclusion}`
    );
  },
  getTransactionWireless(params) {
    var data = "?";
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.terminal_id !== null &&
      params.terminal_id !== undefined &&
      params.terminal_id !== ""
    ) {
      data += `&terminal_id=${params.terminal_id}`;
    }
    if (
      params.transaction_type_id !== null &&
      params.transaction_type_id !== undefined &&
      params.transaction_type_id !== ""
    ) {
      data += `&transaction_type_id=${params.transaction_type_id}`;
    }
    return Rest().get("tripko/transaction/wireless/" + data);
  },
  getTransactionSync(params) {
    var data = "?";
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    if (
      params.sub_company_id !== null &&
      params.sub_company_id !== undefined &&
      params.sub_company_id !== ""
    ) {
      data += `&sub_company_id=${params.sub_company_id}`;
    }
    if (
      params.terminal_id !== null &&
      params.terminal_id !== undefined &&
      params.terminal_id !== ""
    ) {
      data += `&terminal_id=${params.terminal_id}`;
    }
    if (
      params.transaction_type_id !== null &&
      params.transaction_type_id !== undefined &&
      params.transaction_type_id !== ""
    ) {
      data += `&transaction_type_id=${params.transaction_type_id}`;
    }
    return Rest().get("tripko/transaction/sync/" + data);
  },
  getShiftWirelessAndSync(params) {
    var data = "?";
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    if (
      params.aligned !== null &&
      params.aligned !== undefined &&
      params.aligned !== ""
    ) {
      data += `&aligned=${params.aligned}`;
    }
    return Rest().get("tripko/shift/wireless-and-sync" + data);
  },
  shiftSyncToWireless(data) {
    return Rest().post("tripko/shift/sync-to-wireless", data);
  },
  transactionALign(data) {
    return Rest().post("tripko/shift/transaction-align", data);
  },
  getTransactionWirelessAndSync(params) {
    var data = "?";
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    if (
      params.aligned !== null &&
      params.aligned !== undefined &&
      params.aligned !== ""
    ) {
      data += `&aligned=${params.aligned}`;
    }
    return Rest().get("tripko/transaction/wireless-and-sync" + data);
  },
  transactionSyncToWireless(data) {
    return Rest().post("tripko/transaction/sync-to-wireless", data);
  },
  transactionSyncToWirelessAll(data) {
    return Rest().post("tripko/transaction/sync-to-wireless-all", data);
  },
  getCardNumbers(params) {
    let data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }

    return Rest().get("tripko/card-numbers?" + data.substring(1));
  },
  getCardDetails(data) {
    return Rest().get("tripko/get-card-details/" + data);
  },
  getCardExceptions(params) {
    var data = "?";
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    if (
      params.discrepancy_type !== null &&
      params.discrepancy_type !== undefined &&
      params.discrepancy_type !== ""
    ) {
      data += `&discrepancy_type=${params.discrepancy_type}`;
    }
    return Rest().get("tripko/card-exception-report" + data);
  },
  getCardException(data) {
    return Rest().post("tripko/card-exception-report-card", data);
  },
  addMissingTransaction(data) {
    return Rest().put("tripko/card-missing-transaction", data);
  },
  getMissingTransactions(params) {
    var data = "?";
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.date_from !== undefined &&
      params.date_from !== null &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    if (
      params.status_type !== null &&
      params.status_type !== undefined &&
      params.status_type !== ""
    ) {
      data += `&status_type=${params.status_type}`;
    }
    return Rest().get("tripko/card-missing-transaction" + data);
  },

  getReconciledTransactions(body) {
    return Rest().post("tripko/card-reconciled-trans-report", body);
  },
  ReconTransactions(body) {
    return Rest().post("tripko/card-recon-transactions", body);
  },
  ApproveReconTransactions(body) {
    return Rest().post("tripko/card-approve-recon-transactions", body);
  },
  updateReconTransaction(id, body) {
    return Rest().patch("tripko/update-recon-transaction/" + id, body);
  },
  updateApproveReconTransaction(id, body) {
    return Rest().patch("tripko/update-approve-recon-transaction/" + id, body);
  },
  getReconTransChecklist(id) {
    return Rest().post("tripko/card-approve-recon-trans-checklist/" + id);
  },
  getTerminalList() {
    return Rest().post("tripko/card-recon-terminal-list");
  },
  approveMissingTransaction(id, data) {
    return Rest().patch("tripko//card-missing-transaction-approve/" + id, data);
  },
  approveAllMissingTransaction(body) {
    return Rest().patch("tripko//card-missing-transaction-approve-all-1", body);
  },
  approveAllMissingTransaction2(body) {
    return Rest().patch("tripko//card-missing-transaction-approve-all-2", body);
  },

  getMissingTransactionReport(params) {
    var data = "?";
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    if (
      params.transaction_type !== null &&
      params.transaction_type !== undefined &&
      params.transaction_type !== ""
    ) {
      data += `&transaction_type=${params.transaction_type}`;
    }
    return Rest().get("tripko/report/missing-transaction" + data);
  },
  getPreRegisteredCommuters(params) {
    var data = "?";
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }

    return Rest().get("tripko/pre-registered-commuters" + data);
  },
  getPreRegisteredCommuter(id) {
    return Rest().get("tripko/pre-registered-commuter/" + id);
  },
  getRegisteredCommuters(id) {
    return Rest().get("tripko/registered-commuter/" + id);
  },
  approveCommuter(id) {
    return Rest().patch("tripko/approve-commuter/" + id);
  },
  disapproveCommuter(id, data) {
    return Rest().patch("tripko/disapprove-commuter/" + id, data);
  },
  getPreRegisteredCommutersStatus(params) {
    var data = "?";
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.status !== null &&
      params.status !== undefined &&
      params.status !== ""
    ) {
      data += `&status=${params.status}`;
    }

    return Rest().get("tripko/pre-registered-commuters-status" + data);
  },
  releasePreRegisteredCommuter(id, data) {
    return Rest().patch("tripko/release-pre-registered-commuter/" + id, data);
  },
  getTerminals(params) {
    var data = ``;
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.order !== null &&
      params.order !== undefined &&
      params.order !== ""
    ) {
      data += `&order=${params.order}`;
    }
    if (
      params.desc !== false &&
      params.desc !== null &&
      params.desc !== undefined &&
      params.desc !== ""
    ) {
      data += `&desc=${params.desc}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    return Rest().get("tripko/com/terminal?" + data.substring(1));
  },
  getTicketingFraudulentSummary(params) {
    let data = "?";
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    return Rest().get("tripko/ticketing-fraudulent-summary" + data);
  },
  getCardFraudulent(params) {
    let data = "?";
    if (
      params.report_filename !== null &&
      params.report_filename !== undefined &&
      params.report_filename !== ""
    ) {
      data += `&report_filename=${params.report_filename}`;
    }
    return Rest().get("tripko/card-fraudulent-report" + data);
  },
  checkReportDate(params) {
    let data = "?";
    if (
      params.date !== null &&
      params.date !== undefined &&
      params.date !== ""
    ) {
      data += `&date=${params.date}`;
    }
    return Rest().get("tripko/check-report-date" + data);
  },
  generateFraudulentReport(params) {
    let data = "?";
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    return Rest().get("tripko/generate-fraud-report" + data);
  },
  getPromo(params) {
    var data = ``;
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.status !== null &&
      params.status !== undefined &&
      params.status !== ""
    ) {
      data += `&status=${params.status}`;
    }
    // if (
    //   params.type !== null &&
    //   params.type !== undefined &&
    //   params.type !== ""
    // ) {
    //   data += `&type=${params.type}`;
    // }
    if (
      params.sms_status !== null &&
      params.sms_status !== undefined &&
      params.sms_status !== ""
    ) {
      data += `&sms_status=${params.sms_status}`;
    }
    return Rest().post("/tripko/promo?" + data.substring(1));
  },
  uploadSinglePromo(data) {
    return Rest().post("/tripko/promo/upload-single-promo", data);
  },
  getDailyUnitsPerTerminal(params) {
    let data = "?";
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    if (
      params.terminal_id !== null &&
      params.terminal_id !== undefined &&
      params.terminal_id !== ""
    ) {
      data += `&terminal_id=${params.terminal_id}`;
    }
    if (
      params.company_id !== null &&
      params.company_id !== undefined &&
      params.company_id !== ""
    ) {
      data += `&company_id=${params.company_id}`;
    }
    return Rest().get("tripko/report/shift-summary" + data);
  },

  getSoldCredit(params) {
    var data = ``;
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    if (
      params.status !== null &&
      params.status !== undefined &&
      params.status !== ""
    ) {
      data += `&status=${params.status}`;
    }
    return SoldRegisterApi().get("tripko/cmt/all-sold-credit?" + data);
  },
  getSoldVersion(params) {
    var data = ``;
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    return SoldRegisterApi().get("/tripko/cmt/setting-version/all-version");
  },
  getCompanyAssignment(params) {
    var data = ``;
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    return SoldRegisterApi().get(
      "/tripko/cmt/setting-version/assign-version-data?type=web",
    );
  },
  getArrVersions() {
    return SoldRegisterApi().get(
      "/tripko/cmt/setting-version/all-array-version",
    );
  },
  addVersion(body) {
    return SoldRegisterApi().post("tripko/cmt/setting-version/create", body);
  },
  deleteVersion(id) {
    return SoldRegisterApi().delete(
      "/tripko/cmt/setting-version/delete-version/" + id,
    );
  },
  assignVersion(data) {
    return SoldRegisterApi().post(
      "/tripko/cmt/setting-version/assign-company",
      data,
    );
  },
  getSoldCreditDetails(params) {
    let data = "?";
    if (
      params.card_no !== null &&
      params.card_no !== undefined &&
      params.card_no !== ""
    ) {
      data += `&card_no=${params.card_no}`;
    }
    return Rest().get("tripko/transaction/sold-details-sync" + data);
  },
  getCreditRedeemDetails(params) {
    let data = "?";
    if (
      params.card_no !== null &&
      params.card_no !== undefined &&
      params.card_no !== ""
    ) {
      data += `&card_no=${params.card_no}`;
    }
    return Rest().get("tripko/transaction/credit-redeem-sync" + data);
  },
  resendCode(body) {
    return SoldRegisterApi().post("/tripko/cmt/resend-code", body);
  },
  regenerateCode(body) {
    return SoldRegisterApi().patch("/tripko/cmt/regenerate-code", body);
  },
  cancelledCode(body) {
    return SoldRegisterApi().patch("tripko/cmt/cancelled-code", body);
  },
  getSoldTransaction(card_no) {
    let data = "?";

    if (card_no !== null && card_no !== undefined && card_no !== "") {
      data += `&card_no=${card_no}`;
    }
    return Rest().get("tripko/sold-transaction-sync" + data);
  },
  manualInsertSoldRegTransaction(params) {
    return SoldRegisterApi().post(
      "tripko/cmt/manual/card-sold-register",
      params,
    );
  },
  manualInsertCreditRedeem(params) {
    return SoldRegisterApi().post(
      "tripko/cmt/manual/card-credit-redeem",
      params,
    );
  },
  manualInsertAggreCard(params) {
    return ManualAggregateApi().post(
      "/aggregate/manual-insert/all-card-trans/basic-manual-aggregate",
      params,
    );
    //   {
    //     timeout: 0,
    //   }
    // )
    // .then((response) => {
    //   return response;
    // })
    // .catch((error) => {
    //   return error;
    // });
  },
  manualInsertAggreCardTransactionSync(params) {
    return ManualAggregateApi()
      .post(
        "/aggregate/manual-insert/all-card-trans/card-transaction-sync",
        params,
        {
          timeout: 0,
        },
      )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  manualInsertAggreCardMissingTransaction(params) {
    return ManualAggregateApi()
      .post(
        "/aggregate/manual-insert/all-card-trans/card-missing-transaction",
        params,
        {
          timeout: 0,
        },
      )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  manualTimeRangedInsertAggreCard(params) {
    return ManualAggregateApi().post(
      "/aggregate/manual-insert/all-card-trans/time-ranged-manual-aggregate",
      params,
    );
  },
  getDuplicateData(params) {
    return ManualAggregateApi().post(
      "/aggregate/manual-insert/selected-card/check-duplicates",
      params,
    );
  },
  getOperationsAuditData(params) {
    return ManualAggregateApi().post("/aggregate/get-ops-audit-list", params);
  },
  getShiftWirelessLegacy(params) {
    var data = "?";
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    return Rest().get("tripko/shift/legacy/init-details-wireless" + data);
  },
  getShiftWirelessDetails(params) {
    var data = "?";
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    return Rest().get("tripko/shift/legacy/add-details-wireless" + data);
  },
  getTransferTransaction(params) {
    var data = ``;
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.date_from !== null &&
      params.date_from !== undefined &&
      params.date_from !== ""
    ) {
      data += `&date_from=${params.date_from}`;
    }
    if (
      params.date_to !== null &&
      params.date_to !== undefined &&
      params.date_to !== ""
    ) {
      data += `&date_to=${params.date_to}`;
    }
    if (
      params.payment_type !== null &&
      params.payment_type !== undefined &&
      params.payment_type !== ""
    ) {
      data += `&payment_type=${params.payment_type}`;
    }
    return TransferApi().get("cmt/tripko/transfer/transactions?" + data.substring(1));
  },
  getPaymentTypes(params) {
    var data = ``;
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    return Rest().get("tripko/payment-types?" + data.substring(1));
  },
  getPaymentType(id) {
    var data = ``;
    if (id !== null && id !== undefined && id !== "") {
      data += `id=${id}`;
    }
    return Rest().get("tripko/payment-type?" + data);
  },
  addPaymentType(body) {
    return Rest().post("tripko/add-payment-type/", body);
  },
  updatePaymentType(body) {
    return Rest().patch("tripko/update-payment-type/", body);
  },
  softDeletePaymentType(id) {
    return Rest().patch("tripko/soft-delete-payment-type/" + id);
  },
  getCashback(params) {
    var data = ``;
    if (
      params.search !== null &&
      params.search !== undefined &&
      params.search !== ""
    ) {
      data += `&search=${params.search}`;
    }
    if (
      params.limit !== null &&
      params.limit !== undefined &&
      params.limit !== ""
    ) {
      data += `&limit=${params.limit}`;
    }
    if (
      params.offset !== null &&
      params.offset !== undefined &&
      params.offset !== ""
    ) {
      data += `&offset=${params.offset}`;
    }
    if (
      params.status !== null &&
      params.status !== undefined &&
      params.status !== ""
    ) {
      data += `&status=${params.status}`;
    }
    if (
      params.type !== null &&
      params.type !== undefined &&
      params.type !== ""
    ) {
      data += `&type=${params.type}`;
    }
    if (
      params.sms_status !== null &&
      params.sms_status !== undefined &&
      params.sms_status !== ""
    ) {
      data += `&sms_status=${params.sms_status}`;
    }
    return Rest().get("/tripko/cashback?" + data.substring(1));
  },
  cancelCashback(params) {
    return Rest().post("/tripko/cancel-cashback/", params);
  },
  addCashback(data) {
    return Rest().put("/tripko/add-cashback", data);
  },
};
